import React from "react";

/**
 * Catches render-time exceptions in the routed page tree so a single crash
 * surfaces a readable message instead of collapsing the whole app to a blank
 * white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Caught render error:", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const error = this.state.error;
      const message = error?.message || String(error) || "Unknown error";
      return (
        <div style={{ padding: "32px", maxWidth: "900px", margin: "0 auto" }}>
          <h2 style={{ color: "#b91c1c", marginBottom: "12px" }}>
            Something went wrong on this page.
          </h2>
          <p style={{ color: "#374151", marginBottom: "16px" }}>
            The page failed to render. Details below can help us fix it:
          </p>
          <pre
            style={{
              background: "#f3f4f6",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              padding: "16px",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              color: "#b91c1c",
              fontSize: "13px",
            }}
          >
            {message}
            {error?.stack ? `\n\n${error.stack}` : ""}
          </pre>
          <button
            className="backbutton"
            style={{ marginTop: "16px" }}
            onClick={this.handleReset}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
